<div>
  <div class="wrapper" [@routeAnimations]="o.isActivated && o.activatedRoute.routeConfig.path">
    <router-outlet #o="outlet"></router-outlet>
  </div>

  <prf-add-first-profession-modal></prf-add-first-profession-modal>
</div>
